import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { StorageService } from 'src/app/services/storage.service';
import { UndefinedNullableString } from 'src/app/type-alias';
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  faLock = faLock;
  loginForm = new FormGroup({
    email: new FormControl(''),
    password: new FormControl(''),
  });
  errorString: UndefinedNullableString;
  isSubmitting: boolean = false;

  constructor(
    private auth: AuthserviceService,
    private router: Router,
    private storage: StorageService
  ) {}
  ngOnInit(): void {
    if (this.auth.isLoggedIn() && this.auth.isAuthenticated()) {
      if (this.auth.getUserType() == 'installer') {
        this.router.navigate(['installer']);
      }
    } else {
      this.router.navigate(['/login']);
    }
  }

  async onSubmit(): Promise<void> {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      try {
        const username = this.loginForm.get('email')!.value;
        const password = this.loginForm.get('password')!.value;
        this.errorString = null;
        if (this.loginForm.valid && username && password) {
          if (!this.validate_email(username)) {
            this.errorString =
              'Invalid Email address!, Provide a valid Email ID.';
            this.router.navigate(['/login']);
          } else {
            let user_details = {
              username: username,
              password: password,
              location: 'datastudio',
            };
            const response = await this.auth.login(user_details);
            await this.loginProccessor(response)
          }
        } else {
          this.errorString = 'Username or password cannot be empty';
        }
      } catch (_) {
        this.errorString = 'Something went wrong';
      }
      this.isSubmitting = false;
    }
  }

  async loginProccessor(response:any){
    if ((response?.success ?? false) && response?.data) {
      if(response.data.role == 'administrator'|| response.data.role == 'installer'){
        AppSessionStorageService.twoFactorToken = response.data.validate
        AppSessionStorageService.twoFactorSlug = response.data.slug
        this.router.navigate(['authenticate'], { replaceUrl: true })
      }
    } else {
      this.errorString = response?.message ?? 'Something went wrong';
    }
}

  validate_email(email: string | null): boolean {
    if (email) {
      return emailRegex.test(email);
    } else {
      return true;
    }
  }
}